export { default as AwardsModuleBannerStatistics } from './awards-banner-statistics.jsx';
export { default as AwardsModuleBannerText } from './awards-banner-text.jsx';
export { default as AwardsModuleLandingHeader } from './awards-landing-header.jsx';
export { default as AwardsModuleLandingSlideNavigationBottom } from './awards-landing-slide-navigation-bottom.jsx';
export { default as AwardsModuleLandingSlideNavigationTop } from './awards-landing-slide-navigation-top.jsx';
export { default as AwardsModuleNomineesLandingHeader } from './awards-nominees-landing-header.jsx';
export { default as AwardsModuleSlide } from './awards-slide.jsx';
export { default as AwardsNomineesModuleCategory } from './awards-nominees-category.jsx';
export { default as AwardsNomineesModuleEntrant } from './awards-entrant.jsx';
export { default as ModuleAthlete } from './athlete.jsx';
export { default as ModuleCarousel } from './carousel.jsx';
export { default as ModuleCarouselMap } from './carousel-map.jsx';
export { default as ModuleDownloads } from './downloads.jsx';
export { default as ModuleEmbedCode } from './embed-code.jsx';
export { default as ModuleLargeStats } from './large-stats.jsx';
export { default as ModulePopular } from './popular.jsx';
export { default as ModuleQuote } from './quote.jsx';
export { default as ModuleSingleImage } from './single-image.jsx';
export { default as ModuleTablesContainer } from './tables-container.jsx';
export { default as ModuleText } from './text.jsx';
export { default as ModuleTwoImage } from './two-image.jsx';
export { default as ModuleVideoEmbed } from './video-embed.jsx';
